import React, { useCallback, useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import { ILocalizationContext, LocalizationContext } from '../../../../localizationState/localizationContext';
import { updateRestaurantLocalization } from 'backend/restaurants';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, changeMode, refetchWordings, dataForSubmit, typeOfModalWindow } =
		useContext<ILocalizationContext>(LocalizationContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateRestaurantLocalization(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const resetMode = useCallback(() => {
		changeMode('view');
		changeTypeOfModalWindow(null);
		refetchWordings(true);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={resetMode}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={resetMode}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default ModalWindows;
